import { useEffect, useState } from 'react';

/**
 * 视口全屏时跟踪窗口高度，并在进入全屏后触发一次 resize（便于 ECharts 等重算）。
 * @param enabled - 业务开关（如 enableFullScreen）
 */
export function useFullscreenViewportHeight(
  enabled: boolean,
  isFullScreen: boolean,
): number {
  const [viewportH, setViewportH] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerHeight : 800,
  );

  useEffect(() => {
    if (!enabled || !isFullScreen) return undefined;
    const onResize = (): void => setViewportH(window.innerHeight);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [enabled, isFullScreen]);

  useEffect(() => {
    if (!enabled || !isFullScreen) return undefined;
    const timer = window.setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200);
    return () => clearTimeout(timer);
  }, [enabled, isFullScreen]);

  return viewportH;
}
